import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const aiGeneratedQuestionAnswerAction = createAsyncThunk(
    'ai-question-answer',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/generate-question-answer`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const aiGeneratedQuestionAnswerSlice = createSlice({
    name: 'ai-question-answer',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(aiGeneratedQuestionAnswerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(aiGeneratedQuestionAnswerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(aiGeneratedQuestionAnswerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const aiGeneratedQuestionAnswerReducer = aiGeneratedQuestionAnswerSlice.reducer